export const timestatementTab = {
  recent: 'recent',
  past: 'past',
};
